import { Component, OnInit, Input, ViewChild, EventEmitter, Output, Inject, ElementRef, HostListener } from '@angular/core';
import { PatientSearchService } from 'src/app/patient-search/patient-search.service';
import { Subject } from 'rxjs/Subject';
import { ContactInfo, IPersonalInfo, SearchInfo } from 'src/app/models/IPersonalInfo';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { element } from 'protractor';
import { IPatientSearch } from 'src/app/models/IPatientSearch.model';
import { IOrderNote } from 'src/app/models/IOrderNote';
import { DatePipe } from '@angular/common';
import { MatSidenav, MatDialog, MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { Router } from '@angular/router';
//import { OrderNoteDialogComponent } from '../order-note-dialog/order-note-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { NgxMaskModule } from 'ngx-mask';
import { Location } from '@angular/common';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IAlerts } from 'src/app/models/IAlerts';
import { PopupAlertsComponent } from 'src/app/ChildControls/popup-alerts/popup-alerts.component';
import { LockService } from 'src/app/Services/LockService/lock-service.service';
import { IPatientDetails } from 'src/app/models/IEPrescriptionXMLDTO';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { T } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-ccdasearch-patient',
  templateUrl: './ccdasearch-patient.component.html',
  styleUrls: ['./ccdasearch-patient.component.css']
})
export class CCDASearchPatientComponent implements OnInit {
  @Output() slideclose: EventEmitter<any> = new EventEmitter<any>();
  @Output() patientBanner: EventEmitter<any> = new EventEmitter<any>();
  @Input() screenName: string;
  CCDASearchForm: FormGroup;
  personalInfos: IPersonalInfo[];
  dataSource = new MatTableDataSource();
  // displayedColumns: string[] = ['Photo', 'PatientId', 'Name', 'DOB', 'SSN', 'phone', 'zip', 'Action','dPatId'];
  displayedColumns: string[] = ['Photo', 'dPatId', 'Name', 'DOB', 'SSN', 'phone', 'zip', 'location'];
  results: any;
  searchTerm$ = new Subject<string>();
  orderNote: IOrderNote;
  selectedRowIndex: number = -1;
  searchResultStatus: boolean;
  public lstalerts: IAlerts[];
  public PopUpAlerts: IAlerts[] = [];
  public birthdate: Date;
  fromCCDAdate: Date;
  isdisablebtns: boolean = false;
  rolealert: string = "";
  role: string = "";
  toCCDAdate: Date
  patIdFilter = new FormControl('');
  patNameFilter = new FormControl('');
  patDOBFilter = new FormControl('');
  patSSNFilter = new FormControl('');
  patphoneFilter = new FormControl('');
  patZipFilter = new FormControl('');
  dpatIdFilter = new FormControl('');
  locationFilter = new FormControl('');
  filterValues = { patientId: '', name: '', patDOB: '', ssn: '', phone: '', postalCode: '', dpatId: '', locationName: '' };
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('saveUserId', { static: false }) saveUserId: ElementRef;

  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
      this.SelectedDropDownListId = true
    }
    else {
      event.stopPropagation();
      this.SelectedDropDownListId = false
    }
  }
  constructor(public dialogRef: MatDialogRef<CCDASearchPatientComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder
    , private router: Router
    , private patservice: PatientSearchService
    , private sharedService: SharedService
    , public datepipe: DatePipe
    , public dialog: MatDialog
    , private toastr: ToastrService
    , private bannerService: PatientBannerService
    , private location: Location
    , private spinner: NgxSpinnerService
    , private lockService: LockService,
    private crypto: AESAlgorithm,
    private datePipe: DatePipe
    , private schedulerservice: SchedularServiceService
  ) {
    this.spinner.hide();
    this.personalInfos = null;
    this.dataSource.data = [];
    this.getSystem();
    if (this.data != null) {
      this.fromCCDAdate = this.data.fromDate;
      this.toCCDAdate = this.data.toDate;
    }
  }

  formErrors = {
    'locations': '',
  };
  validationMessages = {
    'locations': {
      'required': 'Location is required.',
    },
  };
  getSystem() {

    if (sessionStorage.getItem("patientName") != null || sessionStorage.getItem("patientName") != undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }

  }
  public onload() {
    ;
    this.clearSearch();
  }

  fnSetLocationFromParent() {
    ;
    this.clearSearch();
    this.dataSource.data = [];
    this.getLocations()
  }
  ngOnInit() {
    ;
    this.CCDASearchForm = this.fb.group({
      patientId: [''],
      lastName: [''],
      firstName: [''],
      DOB: [''],
      SSN: [''],
      postalCode: [''],
      phone: [''],
      isActive: [''],
      dPatId: [''],
      locations: ['', Validators.required],
      IsLocationCheck: [''],
    });
    this.getLocations();
    this.role = sessionStorage.getItem("role");

    this.patIdFilter.valueChanges
      .subscribe(
        patientId => {
          this.filterValues.patientId = patientId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patNameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patDOBFilter.valueChanges
      .subscribe(
        patDOB => {
          this.filterValues.patDOB = patDOB;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patSSNFilter.valueChanges
      .subscribe(
        ssn => {
          this.filterValues.ssn = ssn;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patphoneFilter.valueChanges
      .subscribe(
        phone => {
          this.filterValues.phone = phone;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

    this.patZipFilter.valueChanges
      .subscribe(
        postalCode => {
          this.filterValues.postalCode = postalCode;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.locationFilter.valueChanges
      .subscribe(
        locationName => {
          this.filterValues.locationName = locationName;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.dpatIdFilter.valueChanges
      .subscribe(
        dPatId => {
          this.filterValues.patientId = dPatId;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  searchquery: SearchInfo;
  contactInformation: ContactInfo[];
  ssNumber: string = ''
  phone: string = '';
  postalcodeFormat: string = '';
  onSubmit() {
    // this.searchquery = new SearchInfo;
    //this.spinner.show();
    sessionStorage.removeItem("IsClosed");
    var checkInputControlInfo = this.checkInputControldata();
    if (checkInputControlInfo == false) {
      return false
    } else {
    }
    this.clearfiltervalues();
    this.createsearchquery();

    // this.searchquery.location
    setTimeout(() => {
      this.searchEntryData();
    }, 100);
  }
  public searchloading: boolean = false;
  searchEntryData() {
    this.searchloading = true;
    this.searchResultStatus = false;
    this.personalInfos = [];
    if (this.searchquery && this.searchquery != undefined) {
      this.patservice.searchCCDAEntries(this.searchquery, this.fromCCDAdate, this.toCCDAdate)
        .subscribe((results: IPersonalInfo[]) => {

          this.personalInfos = results;
          if (sessionStorage.getItem("IsClosed") != "yes") {
            //this.spinner.show();
            if (this.personalInfos.length != 0) {
              this.personalInfos.forEach(i => {
                var element = i;

                //******* SSN Number */

                if (i.ssn == undefined || i.ssn == null || i.ssn == '') {
                  this.ssNumber = '';
                } else {
                  this.ssNumber = i.ssn;
                  var ssn = this.ssNumber.substring(0, 3);
                  var ssn1 = this.ssNumber.substring(3, 5)
                  this.ssNumber = ssn + '-' + ssn1 + '-' + this.ssNumber.substring(5, 9)
                }


                //******* Home Phone / Cell Phone */
                if (i.phone == undefined || i.phone == null || i.phone == '') {
                  this.phone = '';
                } else {
                  var phoneNumbers = i.phone;
                  var numberSplit = phoneNumbers.split(',');
                  var cellPhone = numberSplit[0];
                  var homePhone = numberSplit[1];


                  if (homePhone == undefined || homePhone == null || homePhone == '') {

                    var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                    if (cellPhoneFormat == '--') {
                      this.phone = '';
                    } else {
                      this.phone = cellPhoneFormat;
                    }

                  } else {

                    var cellPhoneFormat = cellPhone.substring(0, 3) + '-' + cellPhone.substring(3, 6) + '-' + cellPhone.substring(6, 10);
                    var homePhoneFormat = homePhone.substring(0, 3) + '-' + homePhone.substring(3, 6) + '-' + homePhone.substring(6, 10);
                    this.phone = cellPhoneFormat + ',' + homePhoneFormat;
                  }

                }

                //*******Postal Code  */

                if (i.postalCode != '' || i.postalCode != undefined || i.postalCode != null) {
                  if (i.postalCode.length == 9) {
                    var postalcode = i.postalCode;
                    this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)

                  } else {
                    if (i.postalCode.length == 6 || i.postalCode.length == 7
                      || i.postalCode.length == 8) {

                      var postalcode = i.postalCode;
                      this.postalcodeFormat = postalcode.substring(0, 5) + '-' + postalcode.substring(5, 9)
                    } else {
                      this.postalcodeFormat = i.postalCode;

                    }
                  }

                }

                i.ssn = this.ssNumber;
                i.phone = this.phone;
                i.postalCode = this.postalcodeFormat;

                this.searchloading = false;
              })
            } else {
              this.ssNumber = '';
              this.phone = '';
              this.postalcodeFormat = '';
            }

            if (this.personalInfos.length == 0) {
              this.searchResultStatus = true;
              this.searchloading = false;
            }
            else {
              this.searchResultStatus = false;
            }
            this.personalInfos.forEach((element: IPersonalInfo) => {
              if (element.patientPic && element.patientPic != 'undefined')
                element.patientPic = 'data:image/jpeg;base64,' + element.patientPic;

            });
            this.dataSource.data = this.personalInfos;
            //this.spinner.hide();
            this.dataSource.filterPredicate = this.createFilter();
            this.dataSource.paginator = this.paginator;
          }
          sessionStorage.removeItem("IsClosed");
        },
          (err: any) => {
            console.log(err)
            this.spinner.hide();
            this.searchResultStatus = false;
            this.searchloading = false;
          });
    } else {
      // this.dataSource.data = [];
      // alert('no data found.')
    }
  }

  checkInputfields: boolean = false;
  checkInputControldata() {
    if (this.CCDASearchForm.value.patientId == "" && this.CCDASearchForm.value.lastName == "" && this.CCDASearchForm.value.firstName == ""
      && this.CCDASearchForm.value.DOB == "" && this.CCDASearchForm.value.SSN == "" && this.CCDASearchForm.value.locations == ""
      && this.CCDASearchForm.value.phone == "" && this.CCDASearchForm.value.postalCode == "") {
      this.toastr.error('Please select atleast one field.')
      this.dataSource.data = [];
      this.checkInputfields = false;
    } else {
      this.checkInputfields = true;
    }
    return this.checkInputfields;
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.dPatId.toString().indexOf(searchTerms.patientId) !== -1
        && data.name.toString().toLowerCase().indexOf(searchTerms.name) !== -1
        && data.patDOB.toString().toLowerCase().indexOf(searchTerms.patDOB) !== -1
        && data.ssn.toString().toLowerCase().indexOf(searchTerms.ssn) !== -1
        && data.phone.toString().toLowerCase().indexOf(searchTerms.phone) !== -1
        && data.postalCode.toString().toLowerCase().indexOf(searchTerms.postalCode) !== -1
        // && data.locationName.toString().toLowerCase().indexOf(searchTerms.locationName) !== -1
        && (data.locationName === null ? "" : data.locationName).toString().toLowerCase().indexOf(searchTerms.locationName.toLowerCase()) !== -1

        ;

    }
    return filterFunction;
  }

  createsearchquery() {
    if (this.CCDASearchForm.value != null) {
      this.searchquery = {
        patientId: null,
        lastName: '',
        firstName: '',
        DOB: '',
        SSN: '',
        ZIP: '',
        phone: '',
        userid: '',
        isActive: null,
        facilityId: null,
        locationId: '',
      }
      if (this.CCDASearchForm.value.patientId != 'undefined' && this.CCDASearchForm.value.patientId)
        this.searchquery.patientId = this.CCDASearchForm.value.patientId;
      if (this.CCDASearchForm.value.lastName != 'undefined' && this.CCDASearchForm.value.lastName)
        this.searchquery.lastName = this.CCDASearchForm.value.lastName;
      else {
        this.searchquery.lastName = null;
      }
      if (this.CCDASearchForm.value.firstName != 'undefined' && this.CCDASearchForm.value.firstName)
        this.searchquery.firstName = this.CCDASearchForm.value.firstName;
      else {
        this.searchquery.firstName = null;
      }
      if (this.CCDASearchForm.value.DOB != 'undefined' && this.CCDASearchForm.value.DOB) {
        var selecteddate = this.datepipe.transform(this.CCDASearchForm.value.DOB, 'yyyy-MM-dd');
        this.searchquery.DOB = selecteddate;
      } else {
        this.searchquery.DOB = null;
      }
      if (this.CCDASearchForm.value.SSN != 'undefined' && this.CCDASearchForm.value.SSN)
        this.searchquery.SSN = this.CCDASearchForm.value.SSN;
      else {
        this.searchquery.SSN = null;
      }
      if (this.CCDASearchForm.value.phone != 'undefined' && this.CCDASearchForm.value.phone)
        this.searchquery.phone = this.CCDASearchForm.value.phone;
      else {
        this.searchquery.phone = null;
      }
      if (this.CCDASearchForm.value.postalCode != 'undefined' && this.CCDASearchForm.value.postalCode)
        this.searchquery.ZIP = this.CCDASearchForm.value.postalCode;
      else {
        this.searchquery.ZIP = null;
      }
      // if (typeof this.CCDASearchForm.value.isActive != 'undefined' && this.CCDASearchForm.value.isActive)
      //   this.searchquery = this.searchquery + "isActive=false" + "&&";
      if (this.CCDASearchForm.value.isActive)
        this.searchquery.isActive = this.CCDASearchForm.value.isActive;

      if (typeof this.locationID[0].locationName != 'undefined' && this.locationID[0].locationName != "") {
        if (this.selectedLocationIds.length == 0)
          this.selectedLocationIds[0] = '0';
        this.searchquery.locationId = this.selectedLocationIds.toString();
      }
      else if (this.locationID[0].locationName == "")
        this.searchquery.locationId = '0';
      // else if (this.searchquery != '')
      //   this.searchquery = this.searchquery + "isActive=true" + "&&";
      if (this.searchquery != null && this.searchquery != undefined)
        this.searchquery.facilityId = Number(sessionStorage.getItem('FacilityId'));
      //this.searchquery = this.searchquery.substring(0, this.searchquery.length - 2);
    }
  }

  clearSearch() {
    ;
    try {
      this.searchResultStatus = false;
      this.searchloading = false;
      //this.patIdFilter = new FormControl('');
      if (this.CCDASearchForm != null) {
        if (this.CCDASearchForm.value) {
          this.CCDASearchForm.reset({
            'dPatId': '',
            'patientId': '',
            'lastName': '',
            'firstName': '',
            'DOB': '',
            'SSN': '',
            'phone': '',
            'postalCode': '',
            'isActive': '',
          });
        }
        this.selectedLocationIds = [];
        if (this.lstLocations) {
          for (let index = 0; index < this.lstLocations.length; index++) {
            this.lstLocations[index].selected = false;
          }
        }
      }
      if (this.personalInfos != undefined) {
        if (this.personalInfos.length > 0) {
          this.personalInfos = [];
          this.dataSource.data = [];
        }
      }


      this.clearfiltervalues();
    }
    catch (ex) {
      console.log(ex);

    }
  }

  clearfiltervalues() {
    this.patIdFilter.setValue("");
    this.patNameFilter.setValue("");
    this.patDOBFilter.setValue("");
    this.patSSNFilter.setValue("");
    this.patphoneFilter.setValue("");
    this.patZipFilter.setValue("");
    this.dpatIdFilter.setValue("");
    this.locationFilter.setValue("");
  }

  close() {
    ;
    this.clearSearch();
    try {
      if (sessionStorage.getItem("ispatSerachPopup") == "True") {

        this.dialogRef.close();

      }

      this.slideclose.emit("close");
      //this.dialogRef.close();
    }
    catch
    {
      this.slideclose.emit("close");
      // this.dialogRef.close();
    }
    sessionStorage.setItem("IsClosed", "yes");
  }

  oncellclick(element) {

    if (sessionStorage.getItem("ispatSerachPopup") == "True")
      this.dialogRef.close(element);
    // else
    //   this.getPopupAlertsInfo(element.patientId);

  }


  patientAppointments(selectedRow: IAppointmentData) {
    this.close();
    if (selectedRow != null) {
      this.clearLock();
      this.selectedRowIndex = selectedRow.patientId;
      this.bannerService.toggle(selectedRow.patientId);
      sessionStorage.setItem("patientId", selectedRow.patientId.toString());
      sessionStorage.setItem("patientName", selectedRow.name);
      CommonComponents.patientId = selectedRow.patientId;
      CommonComponents.patientName = selectedRow.name;
      sessionStorage.removeItem("displayappDate");
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/PatientAppointments']));

    }
  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  openAlertsPopup(): void {
    const dialogRef = this.dialog.open(PopupAlertsComponent, {
      width: '1000px',
      height: '500px',
      data: this.PopUpAlerts

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)
        this.sharedService.lstPopUpAlerts = null;

    });
  }



  public locationName: number = 0;


  createNewOrder(provider: string, orderDate: any, patId: number, appId: string, patName: string, locationId: number) {
    this.orderNote = new IOrderNote();
    this.orderNote.providerId = provider;
    this.orderNote.appointmentId = appId;
    this.orderNote.patId = patId;
    this.orderNote.locationId = locationId;
    var datePipe = new DatePipe("en-US");
    // this.orderNote.orderDate = new Date(datePipe.transform(orderDate, 'MM/dd/yyyy'));;
    this.orderNote.orderDate = new Date(this.datepipe.transform(orderDate, 'yyyy-MM-dd'));
    this.orderNote.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.patservice.createOrderNote(this.orderNote)
      .subscribe(result => {

        //alert(result)
        localStorage.setItem("ordernoteheaderVisibility", "True");
        CommonComponents.ordernoteheaderVisibility = true;

        if (result == -1) {
          CommonComponents.headerVisibility = false;
          this.toastr.warning("Order Note already created for this appointment");
        }
        else {
          sessionStorage.setItem("encounterid", result);
          CommonComponents.headerVisibility = false;
          this.selectedRowIndex = patId;
          this.bannerService.toggle(patId);
          sessionStorage.setItem("patientId", patId.toString());
          sessionStorage.setItem("patientName", patName);
          sessionStorage.removeItem("displayappDate");
          CommonComponents.patientId = patId;
          CommonComponents.patientName = patName;
          CommonComponents.headerVisibility = false;
          this.toastr.success("Order Note created succesfully");
          this.clearLock();
          this.router.navigateByUrl('/', { skipLocationChange: true, preserveQueryParams: true }).then(() =>
            this.router.navigateByUrl('/OrderNote?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(sessionStorage.getItem("encounterid")))));
        }
      }
      );


  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  alphanumericonly(event): boolean {
    var regex = new RegExp("^[a-zA-Z0-9/b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  validateDate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 47) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  public todayDate = new Date();
  getPopupAlertsInfo(id: number) {
    var todayVisitDate: any = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy')
    this.sharedService.getAlertsInfo(id, todayVisitDate)
      .subscribe(
        (data: any) => {
          this.lstalerts = data;
          this.sharedService.lstPopUpAlerts = this.lstalerts;
          if (CommonComponents.patientId > 0) {
            if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
              var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isDemographics == true && attr.isDismiss == true);
              alertcount = alertcount.filter((attr: IAlerts) => !attr.rolesName || attr.rolesName.includes(sessionStorage.getItem("role")));
              if (alertcount != null && alertcount.length > 0) {
                this.PopUpAlerts = alertcount;
                this.rolealert = "";
                this.PopUpAlerts.forEach(element => {
                  if (element.rolesName != null && element.rolesName != "") {
                    this.rolealert += element.rolesName + ',';
                  }
                });
                if (this.rolealert != null && this.rolealert != undefined && this.rolealert != "") {
                  if (this.rolealert.includes(sessionStorage.getItem("role"))) {
                    this.openAlertsPopup();
                  }
                } else {
                  this.openAlertsPopup();
                }
              }
            }
          }
        },
        (err: any) => console.log(err)
      );
  }


  clearLock() {
    this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
    },
      (err: any) => console.log(err)
    );
  }

  NavigatetoPersonal(ele: any) {
    if (ele && ele != undefined) {
      if (ele.patientId > 0) {
        this.getPopupAlertsInfo(ele.patientId);
      }

      CommonComponents.patientId = ele.patientId;
      CommonComponents.patientName = ele.name;
      this.bannerService.toggle(ele.patientId);
      sessionStorage.setItem("patientId", ele.patientId.toString());
      sessionStorage.setItem("patientName", ele.name);
      sessionStorage.removeItem("displayappDate");
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      sessionStorage.removeItem("AlertsheaderIconVisibility");
      CommonComponents.demoheaderVisibility = true;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/Demographics/Personal']));
      this.close();
    }

  }

  //********* Newly Added Multiselect dropdown */
  UsersFocus() {
    //  $('#Usersfocushide').show();
    this.SelectedDropDownListId = true;
  }
  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {
      $('#locationsfocushide').hide()
      setTimeout(() => {
        this.saveUserId.nativeElement.focus();
      }, 100);

      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus") {
      $('#locationlistoption0').focus();
    }
  }

  SelectedDropDownListId: boolean = false;
  arryOfselectedLocationsIdsUpdate: string[] = [];
  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  selectedLocationIds: string[] = [];
  LocationSelectionChanged(LocationupdateRef) {
    ;
    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value);
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = [];
    this.selectedLocationIds = [];
    this.arryOfselectedLocationsIdsUpdate = [];
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    if (this.locationsList.length > 0 && this.locationsList != null)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;

    this.lstLocations.filter(x => x.selected = false) // default set false
    this.lstLocations.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)

    this.CCDASearchForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2)
    })

    this.checkDefaultLocations();

  }
  checkDefaultLocations() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations.length) {
        this.CCDASearchForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.CCDASearchForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.CCDASearchForm.patchValue({
        IsLocationCheck: false
      });
    }

    if (selectProvlst.length > 0 || this.locationsList.length > 0)
      this.isdisablebtns = false;
    else
      this.isdisablebtns = true;
  }
  public lstLocations: ILocationDetails[];
  //public locationFilter: any;
  locationID: any;
  getLocationId: any;
  name: any;
  getLocations() {
    if ((sessionStorage.getItem("userId") || sessionStorage.getItem("FacilityId")))
      this.schedulerservice.getLocations().subscribe(data => {
        this.spinner.hide();
        this.lstLocations = data;
        this.selectedLocationIds = [];
        ;
        this.getLocationId = sessionStorage.getItem("LocationId"); //this.patservice.urlValue;//
        if (this.getLocationId == "0") {
          this.locationID = this.lstLocations[0].locationName.toString();
          this.isdisablebtns = true
        } else {
          this.locationID = this.lstLocations.filter(x => x.locationId === Number(this.getLocationId))
          this.selectedLocationIds.push(this.locationID[0].locationId);
          this.isdisablebtns = false;
        }

        this.lstLocations.filter(x => x.selected = false) // default set false
        this.lstLocations.filter(x => x.locationId == this.locationID[0].locationId).map(y => y.selected = true);

        this.CCDASearchForm.patchValue({
          locations: this.locationID[0].locationName,
        });
      });

  }

  selectedList: ILocationDetails[];
  selected: string = "";
  selectedName: string;
  checkAllLocations(event) {

    let ischk: any
    if (event.keyCode == 32) {
      ischk = !event.target.checked
    } else {
      ischk = event.target.checked
    }
    if (ischk == true) {
      this.isdisablebtns = false;
      this.selectedList = [];
      this.selectedLocationIds = [];
      this.selected = '';
      this.locationNameUpdate = '';
      this.lstLocations = this.lstLocations.filter(x => x.selected = true)
      this.selectedList = this.lstLocations;

      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = true;
        this.selected += this.selectedList[index].locationId + ',';
        this.selectedLocationIds.push(this.selectedList[index].locationId.toString())

        //this.selectedLocationIds.push(this.selected);
        // this.selectedLocationIds.push(this.locationsList[index].locationId.toString())
        this.locationNameUpdate += this.selectedList[index].locationName + ', ';
      }
      if (this.selectedList.length != 0) {
        this.locationNameUpdate = this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2);
      }
      this.CCDASearchForm.patchValue({
        locations: this.locationNameUpdate
      });
    } else {
      this.isdisablebtns = true;
      for (let index = 0; index < this.selectedList.length; index++) {
        this.selectedList[index].selected = false;
      }
      this.selectedLocationIds = [];
      //this.selectedLocationIds.push('0')
      this.selected = '';
      this.selectedName = '';
      this.CCDASearchForm.patchValue({
        locations: this.selectedName
      });
    }




  }

}
